import React from "react";
import "../../css/Popups/VariantChoicePopup.css";

const VariantChoicePopup = ({ variants, onNew, onCopy, onClose }) => {
  return (
    <div className="popupOverlay">
      <div className="popupContent">
        <div className="popupHeader">
          <h3 className="popupTitle">Dodaj wariant</h3>
          <div className="closeBtn" onClick={onClose}>×</div>
        </div>

        <div className="popupBody">
          <div className="btnPrimary" onClick={onNew}>
            <i className="fas fa-plus"></i> Nowy wariant
          </div>

          <div className="orSeparator">lub</div>

          <div className="copySection">
            <div className="copyLabel">
              <i className="fa-regular fa-copy copyIcon" /> Skopiuj z istniejącego wariantu:
            </div>

            <ul className="variantList">
              {variants.map((variant) => (
                <li key={variant.guid}>
                  <div
                    className={`variantListItem ${variant.isPublished ? "disabled" : ""}`}
                    onClick={() => !variant.isPublished && onCopy(variant.guid)}
                    title={variant.isPublished ? "Nie można skopiować opublikowanego wariantu" : ""}
                  >
                    {variant.name}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VariantChoicePopup;
